<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Researcher</ng-container>
  <ng-container *ngIf="data.id">Edit Researcher</ng-container>
</h1>
<mat-dialog-content>

  <aw-researcher-form [researcher]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-researcher-form>

</mat-dialog-content>